module.exports = __webpack_public_path__ + "static/img/img_16.77055660.png";